import {StockOperationStatus} from "../api";

const stockOperationStatuses: {
    status: StockOperationStatus,
    color: string,
    translation: string,
    processTranslation: string
}[] = [
    {
        status: StockOperationStatus.Draft,
        color: "#808080",
        translation: "Kopia robocza",
        processTranslation: "Wersja robocza"
    },
    {
        status: StockOperationStatus.ForCompletion,
        color: "#FFFF00",
        translation: "Do kompletacji",
        processTranslation: "W toku"
    },
    {
        status: StockOperationStatus.Published,
        color: "#008000",
        translation: "Opublikowano",
        processTranslation: "Zakończony"
    }
];

export const stockOperationStatusTagColorHelper = (status: StockOperationStatus | string) => {
    switch (status) {
        case StockOperationStatus.Draft:
            return 'gray';
        case StockOperationStatus.ForCompletion:
            return 'yellow';
        case StockOperationStatus.Published:
            return 'green';
        default:
            return 'blue';
    }
};

export const stockOperationStatusTranslationHelper = (status: StockOperationStatus | string) =>
    stockOperationStatuses.find(x => x.status === status)?.translation || status;

export const productionProcessStatusTranslationHelper = (status: StockOperationStatus | string) =>
    stockOperationStatuses.find(x => x.status === status)?.processTranslation || status;


export const stockOperationStatusColorHelper = (status: StockOperationStatus) =>
    stockOperationStatuses.find(x => x.status === status)?.color ?? "";

const nextStockOperationStatus: {
    currentStatus: StockOperationStatus,
    nextStatus: StockOperationStatus,
    translation: string
}[] = [
    {
        currentStatus: StockOperationStatus.Draft,
        nextStatus: StockOperationStatus.ForCompletion,
        translation: "Do kompletacji",
    },
    {
        currentStatus: StockOperationStatus.ForCompletion,
        nextStatus: StockOperationStatus.Published,
        translation: "Do publikacji"
    },
];

export const getNextStockOperationStatus = (currentStatus: StockOperationStatus) =>
    nextStockOperationStatus.find(x => x.currentStatus === currentStatus);
